import React,{useEffect} from 'react';
import Header from '../../components/Header';
import StudentRegisterMain from './StudentRegMain';
import Footer from '../../components/Footer';


const StudentRegister = () => {
          useEffect(() => {
          document.title = "Student Membership Registration | Society of Aquaculture Professionals";
        }, []);
  return (
    <>
      <Header/>

      <StudentRegisterMain />

      <Footer/>

    </>
  );
};

export default StudentRegister;
